
import { defineComponent } from "vue"
import CardVersionsForm from "@/components/card_versions/Form.vue"

export default defineComponent({
  components: {
    CardVersionsForm
  }
})
